import { render, staticRenderFns } from "./TenantViewSidebarAdd.vue?vue&type=template&id=c4911d4a&scoped=true&"
import script from "./TenantViewSidebarAdd.vue?vue&type=script&lang=js&"
export * from "./TenantViewSidebarAdd.vue?vue&type=script&lang=js&"
import style0 from "./TenantViewSidebarAdd.vue?vue&type=style&index=0&id=c4911d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4911d4a",
  null
  
)

export default component.exports